import { useEffect, useMemo, useState, RefObject } from 'react';

const useOnScreen = (
  ref: RefObject<HTMLElement>,
  intersectionOptions?: IntersectionObserverInit
): boolean => {
  const [isVisible, setIsVisible] = useState(false);

  const options = useMemo<IntersectionObserverInit | undefined>(
    () => intersectionOptions,
    [intersectionOptions]
  );

  useEffect(() => {
    if (ref.current == null) return;

    const observer = new IntersectionObserver(
      ([entry]) => setIsVisible(entry.isIntersecting),
      options
    );

    observer.observe(ref.current);

    return (): void => {
      if (ref.current == null) return;

      observer.unobserve(ref.current);
    };
  }, [ref.current, options]);

  return isVisible;
};

export default useOnScreen;
